<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three">
        <div>
          <div class="title_div">
            <span class="title-span">门店:</span>
            <el-select
              filterable
              clearable
              v-model="hdParams.shopId"
              size="small"
              class="title-select"
              @change="mdStortChange"
            >
              <el-option
                v-for="item in mdSelectList"
                :value="item.id"
                :key="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
            <span class="title-span">活动:</span>
            <el-select
              clearable
              v-model="hdParams.eventId"
              size="small"
              class="title-select"
              @change="hdStortChange"
            >
              <el-option
                v-for="item in hdSelectList"
                :value="item.id"
                :key="item.id"
                :label="item.title"
              ></el-option>
            </el-select>
            <span class="title-span">日期:</span>
            <el-date-picker
              v-model="hdParams.createDateStart"
              @change="hdStartChange"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="hdParams.createDateEnd"
              @change="hdEndChange"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="copyAll"
              >批量导出</el-button
            >
          </div>
          <div class="mm-tb">
            <el-table :data="hdList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="membersName"
                label="会员姓名"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="membersPhone"
                label="手机号码"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="eventName" label="报名活动" align="center">
              </el-table-column>
              <el-table-column prop="shopName" label="门店" align="center">
              </el-table-column>
              <el-table-column prop="signDate" label="报名日期" align="center">
              </el-table-column>
              <el-table-column prop="signDate" label="报名时间" align="center">
              </el-table-column>
              <el-table-column prop="dateEnd" label="截止日期" align="center">
              </el-table-column>
              <el-table-column prop="address" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="copyHd(scope.row)"
                    >复制</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="hdSizeChange"
              @current-change="hdCurrentChange"
              :current-page="hdResult.current"
              :page-size="hdResult.size"
              layout="total,prev, pager, next, sizes"
              :total="hdResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getEventSignPage,
  getEventSignForExcel,
  getAntEventForSelect,
} from "../../api/OperationManagement.js";
import { getAntDeptSelect } from "../../api/BusinessManagement";
import { getAntMembersForExcel } from "../../api/MemberManagement";

export default {
  name: "3ActivityRegistration",
  data() {
    return {
      activeName: "three",
      hdParams: {
        createDateStart: "",
        createDateEnd: "",
        eventId: "",
        shopId: "",
        pageNo: 1,
        pageSize: 10,
      },
      hdResult: {},
      hdList: [],
      mdSelectList: [],
      hdSelectList: [],
    };
  },
  mounted() {
    this.getEventSignPage(this.hdParams);
    this.getAntDeptSelect();
    this.getAntEventForSelect();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        // this.$router.push('/OperationManagement/3ActivityRegistration');
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    hdSizeChange(newSize) {
      this.hdParams.pageSize = newSize;
      this.getEventSignPage(this.hdParams);
    },
    hdCurrentChange(newPage) {
      this.hdParams.pageNo = newPage;
      this.getEventSignPage(this.hdParams);
    },
    //获取活动列表
    getEventSignPage(params) {
      getEventSignPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.hdResult = res.data.result;
            this.hdList = res.data.result.records;
          } else {
            this.hdResult = res.data.result;
            this.hdList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //活动开始时间改变
    hdStartChange(val) {
      if (
        this.hdParams.createDateStart &&
        this.hdParams.createDateEnd &&
        new Date(this.hdParams.createDateStart).getTime() >
          new Date(this.hdParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hdParams.pageNo = 1;
      this.getEventSignPage(this.hdParams);
    },
    //活动结束时间改变
    hdEndChange(val) {
      if (
        this.hdParams.createDateStart &&
        this.hdParams.createDateEnd &&
        new Date(this.hdParams.createDateStart).getTime() >
          new Date(this.hdParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hdParams.pageNo = 1;
      this.getEventSignPage(this.hdParams);
    },
    mdStortChange(val) {
      this.hdParams.pageNo = 1;
      this.getEventSignPage(this.hdParams);
    },
    //活动改变
    hdStortChange(val) {
      this.hdParams.pageNo = 1;
      this.getEventSignPage(this.hdParams);
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.mdSelectList = res.data.result;
        }
      });
    },
    getAntEventForSelect() {
      getAntEventForSelect({ eventType: 1 }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.hdSelectList = res.data.result;
        }
      });
    },
    //复制一条
    copyHd(r) {
      //console.log(r)
      var text =
        "会员姓名:" +
        r.membersName +
        ";手机号码:" +
        r.membersPhone +
        ";报名活动:" +
        r.eventName +
        ";门店:" +
        r.shopName +
        ";报名日期:" +
        r.signDate +
        ";报名时间:" +
        r.signDate +
        ";截止日期:" +
        r.dateEnd;
      this.copyText(text);
    },
    //获取文字到粘贴板
    copyText(text) {
      var textarea = document.createElement("input"); //创建input对象
      var currentFocus = document.activeElement; //当前获得焦点的元素
      document.body.appendChild(textarea); //添加元素
      textarea.value = text;
      textarea.focus();
      if (textarea.setSelectionRange) {
        textarea.setSelectionRange(0, textarea.value.length);
      } //获取光标起始位置到结束位置
      else {
        textarea.select();
      }
      try {
        var flag = document.execCommand("copy"); //执行复制
      } catch (eo) {
        var flag = false;
      }
      document.body.removeChild(textarea); //删除元素
      currentFocus.focus();
      //console.log(flag)
      if (flag) {
        this.$message.success("复制数据成功！");
      } else {
        this.$message.error(res.message);
      }
      return flag;
    },
    //批量导出
    copyAll() {
      const params = { ...this.hdParams };
      delete params.createDateStart;
      delete params.createDateEnd;
      delete params.shopId;
      delete params.eventId;
      console.log(params);
      getEventSignForExcel(params).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "活动报名"; // sessionStorage.realName + timestr　　　　　　　　// xxx.xls/xxx.xlsx
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>
